<template>
	<div id="app">
		<div id="nav">
			<!-- <router-link to="/">Home</router-link> -->
			<!-- <HomeIndex></HomeIndex> -->
			<router-view />
		</div>
	</div>
</template>
<script>
	
		
		
	
	// window.addEventListener('storage',function (e){
	// 	console.log('e')
	// 	console.log(e)
	//     if(e.key == 'code'){
	//         var selectInfoObj = JSON.parse(e.newValue);
	// 		console.log(selectInfoObj);
	//         // that.reseverBtnText = '（ '+selectInfoObj.seatName+' 低消'+selectInfoObj.minConsumption+'元 ）';
	//     };
	// });
	
	
	
	
	// import HomeIndex from "./components/Home/HomeIndex.vue"
	// window.onbeforeunload = function() {
	// 	if (event.clientX > document.body.clientWidth && event.clientY < 0 || event.altKey) {
	// 		var storage = window.localStorage; //方法
	// 		storage.clear()
	// 	}
	// }
	
	export default {
		name: "App",
		data: {
			
	    },
		
		methods:{
			
			// ComputetTime(data) {
			//   let st = data.currentTime.replace(/\-/g, "/"),//当前服务器时间
			//     ct = data.formatCreateTime.replace(/\-/g, "/");//创建订单时间
			//   let ts = new Date(st).getTime(),
			//     tc = new Date(ct).getTime();
			//   let cm = 15 * 60 * 1000 - (ts - tc);
			//   this.runBack(cm);
			// },
			// runBack(cm) {
			//   if (cm > 0) {
			// 	cm > 60000
			// 	  ? (this.rocallTime =
			// 	  (new Date(cm).getMinutes() < 10
			// 		? "0" + new Date(cm).getMinutes()
			// 		: new Date(cm).getMinutes()) +
			// 	  ":" +
			// 	  (new Date(cm).getSeconds() < 10
			// 		? "0" + new Date(cm).getSeconds()
			// 		: new Date(cm).getSeconds()))
			// 	  : (this.rocallTime =
			// 	  "00:" +
			// 	  (new Date(cm).getSeconds() < 10
			// 		? "0" + new Date(cm).getSeconds()
			// 		: new Date(cm).getSeconds()));
			// 	let _msThis = this;
			// 	setTimeout(function() {
			// 	  cm -= 1000;
			// 	  _msThis.runBack(cm);
			// 	}, 1000);
			//   } else {
			// 	this.changeOrderState();//调用改变订单状态接口
			//   }
			// },
		},
		beforeCreate() {
			// if(this.$storage.getLocal('iskey')){
			// 	console.log(this.$setTimes)
			// }
			// console.log(this.$storage.getLocal('iskey'))
		},
		created() {
			
		},
		components: {
			// HomeIndex
		},
		computed: {
			
		}
	}
</script>

<style>
	@font-face {
	  font-family: 'iconfont';  /* project id 2315885 */
	  src: url('//at.alicdn.com/t/font_2315885_f9czmvjcxze.eot');
	  src: url('//at.alicdn.com/t/font_2315885_f9czmvjcxze.eot?#iefix') format('embedded-opentype'),
	  url('//at.alicdn.com/t/font_2315885_f9czmvjcxze.woff2') format('woff2'),
	  url('//at.alicdn.com/t/font_2315885_f9czmvjcxze.woff') format('woff'),
	  url('//at.alicdn.com/t/font_2315885_f9czmvjcxze.ttf') format('truetype'),
	  url('//at.alicdn.com/t/font_2315885_f9czmvjcxze.svg#iconfont') format('svg');
	}
	#app{
		font-size: 1rem;
	}
</style>
